import React from 'react';
import { DateTime } from 'luxon';


import { formatTimestamp, isoToRelative } from 'utils/time';
import { fontWeights, fontStyles, fontSizes } from 'utils/font';


const TimeStamp = ({ timestamp, isRelative, fontSize = fontSizes.medium, fontWeight = fontWeights.normal, fontStyle = fontStyles.normal }) => {
  return (
    <div style={{ fontWeight: fontWeight, fontStyle: fontStyle, fontSize: fontSize }}>
      { isRelative ? isoToRelative(DateTime.fromISO(timestamp)) : formatTimestamp(DateTime.fromISO(timestamp)) }
    </div>
  );
};

export default TimeStamp;
